export const NumberInHouseholds = [
  '',
  '2',
  '1',
  '3',
  '4',
  '5+',
  'Prefer not to answer'
];

export type NumberInHousehold = (typeof NumberInHouseholds)[number];
